import { sortBy } from 'lodash';
import { connect, Dispatch } from 'react-redux';

import { UrlHelpers } from '../../service/UrlHelpers';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';
import {
    cancelCreation,
    createCreative,
    hideError,
    Html5UploadAction,
    saveUploadName,
    upload,
    uploadCancelled
} from '../Html5App/actions';
import { Html5State } from '../Html5App/state';

import { Html5Upload, Html5UploadProps } from './Html5Upload';
import { UploadCreative } from './typings';

type DispatchProps = TDispatchProps<Html5UploadProps>;
const mapDispatchToProps = (dispatch: Dispatch<Html5UploadAction>): DispatchProps => {
    return {
        upload: (creatives: UploadCreative[]) => dispatch(upload(creatives)),
        submit: () => dispatch(createCreative()),
        hideError: () => dispatch(hideError()),
        cancel: () => dispatch(cancelCreation()),
        cancelUpload: (creative: UploadCreative) => dispatch(uploadCancelled(creative)),
        saveUploadName: (name: string) => dispatch(saveUploadName(name))
    };
};

type StateProps = TStateProps<Html5UploadProps>;

const mapStateToProps = (state: State): StateProps => {
    const html5CanvasEditor: Html5State = state.canvasEditor.html5;
    const { uploadCreatives, productType } = html5CanvasEditor;
    const { name, creatives } = uploadCreatives;

    const creativesArray = sortBy(Object.keys(creatives).map(id => creatives[id]), item => item.fileId);
    return {
        creatives: creativesArray,
        error: state.canvasEditor.html5.error,
        name,
        isBusy: state.canvasEditor.html5.isBusy,
        helpUrl: UrlHelpers.getHtml5HelpUrl(productType)
    };
};

export const Html5UploadContainer = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(Html5Upload);
